import type { Customer } from "../../../core/schema/Customer.js";
import { localStorageWritable } from "../../../core/utils/localStorageWritable.js";

export const loggedCustomerStore = localStorageWritable<Customer | undefined>("loggedCustomer", undefined);
